"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2020, a Tencent company. All rights reserved
 */
exports["default"] = {
  componentName: 'odc-frame',
  componentVersion: '0.0.0',
  name: 'odc-frame',
  version: '0.0.0'
};